import { type TypedDocumentNode, gql } from '@apollo/client';

import { BlueprintRevealStatus } from '@sorare/core/src/__generated__/globalTypes';

import { CelebrationDisclaimer } from './CelebrationDisclaimer';
import type { BlueprintDisclaimer_AnyCardInterface } from './__generated__/index.graphql';

type Props = { card: BlueprintDisclaimer_AnyCardInterface };

export const BlueprintDisclaimer = ({ card }: Props) => {
  if (
    !card.blueprint ||
    card.blueprint.revealStatus === BlueprintRevealStatus.REVEALED
  ) {
    return null;
  }

  if (card.cardEditionName?.match(/neon.christmas/i)) {
    return null;
  }

  if (card.cardEditionName?.match(/celebration/i)) {
    return <CelebrationDisclaimer />;
  }

  return null;
};

BlueprintDisclaimer.fragments = {
  AnyCardInterface: gql`
    fragment BlueprintDisclaimer_AnyCardInterface on AnyCardInterface {
      slug
      cardEditionName
      blueprint {
        id
        revealStatus
      }
    }
  ` as TypedDocumentNode<BlueprintDisclaimer_AnyCardInterface>,
};
